export class ReportWithAlias {
  id: string;
  reportName: string;
  alias: string = '';
  hexColorClass: string = '';
}
